$(document).ready(function(){

  $('.cyb-tab-button').on('click',function(){
    if($(this).hasClass('active')){
      return false;
    }
    $('.cyb-tab-button').removeClass('active');
    $(this).addClass('active');
    var id = $(this).attr('data-id');
    $('.ct-wrapper').removeClass('active');
    $('.ct-wrapper[data-id='+id+']').addClass('active');
  });
  
  $('.cyb-tabs-select').on('change',function(){
    var id = $(this).find(':selected').attr('data-id');
    console.log(id);
    $('.ct-wrapper').removeClass('active');
    $('.ct-wrapper[data-id='+id+']').addClass('active');
  });

  $('.cyb-popup-trigger').on('click',function(e){
    e.preventDefault();
    $('body').addClass('locked')
    var id = $(this).attr('data-id');
    $('.cyb-sorted-popup-outer[data-id='+id+']').show();
  });

  $('.cyb-sorted-popup-close').on('click',function(e){
    e.preventDefault();
    $('body').removeClass('locked')
    $(this).closest('.cyb-sorted-popup-outer').hide();
  });
  
  //handle hiding popup with esc key or clicking out of modal box
  $(document).keyup(function(e) {
      if(e.key === "Escape") { // escape key maps to keycode `27`
          $('body').removeClass('locked')
          $('.cyb-sorted-popup-outer').hide();
      }
  });

  $('body').on('click','.cyb-sorted-popup-outer',function(e){
      if(e.target.className == 'cyb-sorted-popup-outer'){
          $('body').removeClass('locked')
          $('.cyb-sorted-popup-outer').hide();
      }
  });

  if($('.cyb-promo-swiper').length > 0){
    var prot = $('.cyb-promo-swiper').attr('data-auto');
    var pspd = $('.cyb-promo-swiper').attr('data-speed');
    if(prot == 'true'){
      var promo = new Swiper('.cyb-promo-swiper', {
        // Optional parameters
        loop: true,  
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          clickable:true
        },
        autoplay:{
          delay:pspd  
        },
        // Navigation arrows
        navigation: {
          nextEl: '.cyb-promo-next-arrow',
          prevEl: '.cyb-promo-prev-arrow',
        },
        effect:'fade',
        fadeEffect:{
            crossFade:true
        }
      });
    }
    else{
      var promo = new Swiper('.cyb-promo-swiper', {
        // Optional parameters
        loop: true,  
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          clickable:true
        },
        // Navigation arrows
        navigation: {
          nextEl: '.cyb-promo-next-arrow',
          prevEl: '.cyb-promo-prev-arrow',
        },
        effect:'fade',
        fadeEffect:{
            crossFade:true
        }
      });
    }
  
  }
  
  if($('.cyb-intro-swiper').length > 0){
    var Irot = $('.cyb-intro-swiper').attr('data-auto');
    var Ispd = $('.cyb-intro-swiper').attr('data-speed');
    if(Irot == 'true'){
      var intro = new Swiper('.cyb-intro-swiper', {
        // Optional parameters
        loop: true,  
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          clickable:true
        }, 
        autoplay: {
          delay: Ispd
        },          
        // Navigation arrows
        navigation: {
          nextEl: '.cyb-intro-next-arrow',
          prevEl: '.cyb-intro-prev-arrow',
        },
        effect:'fade',
        fadeEffect:{
            crossFade:true
        }
      });
    }
    else{
      var intro = new Swiper('.cyb-intro-swiper', {
        // Optional parameters
        loop: true,  
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          clickable:true
        },          
        // Navigation arrows
        navigation: {
          nextEl: '.cyb-intro-next-arrow',
          prevEl: '.cyb-intro-prev-arrow',
        },
        effect:'fade',
        fadeEffect:{
            crossFade:true
        }
      });
    }
  }
  
  if($('.cyb-location-swiper').length > 0){
    var lrot = $('.cyb-location-swiper').attr('data-auto');
    var lspd = $('.cyb-location-swiper').attr('data-speed');
    if(lrot == 'true'){
      var locslide = new Swiper('.cyb-location-swiper', {
        // Optional parameters
        loop: true,  
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          clickable:true
        }, 
        autoplay: {
          delay: lspd
        },
        // Navigation arrows
        navigation: {
          nextEl: '.cyb-location-next-arrow',
          prevEl: '.cyb-location-prev-arrow',
        },
        effect:'fade',
        fadeEffect:{
            crossFade:true
        }
      });
    }
    else {
      var locslide = new Swiper('.cyb-location-swiper', {
        // Optional parameters
        loop: true,  
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          clickable:true
        },          
        // Navigation arrows
        navigation: {
          nextEl: '.cyb-location-next-arrow',
          prevEl: '.cyb-location-prev-arrow',
        },
        effect:'fade',
        fadeEffect:{
            crossFade:true
        }
      });
    }
  }
  
  if($('.cyb-logo-swiper').length > 0){
    var lgrot = $('.cyb-logo-swiper').attr('data-auto');
    var lgspd = $('.cyb-logo-swiper').attr('data-speed');
    if(lgrot == 'true'){
      var logoslide = new Swiper('.cyb-logo-swiper', {
        // Optional parameters
        loop: true,  
        autoplay: {
          delay: lgspd
        },
        // Navigation arrows
        navigation: {
          nextEl: '.cyb-logo-next-arrow',
          prevEl: '.cyb-logo-prev-arrow',
        },
        // Default parameters
        slidesPerView: 2,
        spaceBetween: 10,
        breakpointsBase:'container',
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 480px
          480: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          // when window width is >= 991px
          991: {
            slidesPerView: 5,
            spaceBetween: 40
          },
          // when window width is >= 1100px
          1100: {
            slidesPerView: 5,
            spaceBetween: 40
          },
          // when window width is >= 1400px
          1400: {
            slidesPerView: 6,
            spaceBetween: 40
          }
        }
      });
    }
    else {
      var logoslide = new Swiper('.cyb-logo-swiper', {
        // Optional parameters
        loop: true,  
        // Navigation arrows
        navigation: {
          nextEl: '.cyb-logo-next-arrow',
          prevEl: '.cyb-logo-prev-arrow',
        },
        // Default parameters
        slidesPerView: 2,
        spaceBetween: 10,
        breakpointsBase:'container',
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 480px
          480: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 4,
            spaceBetween: 40
          },
          // when window width is >= 991px
          991: {
            slidesPerView: 5,
            spaceBetween: 40
          },
          // when window width is >= 1100px
          1100: {
            slidesPerView: 5,
            spaceBetween: 40
          },
          // when window width is >= 1400px
          1400: {
            slidesPerView: 6,
            spaceBetween: 40
          }
        }
      });
    }
  }

  if($('.mount-announcement-bar').length > 0){
    var ht = $('.mount-announcement-bar').outerHeight();
    var mht = $('#site-header').outerHeight();
    $('#site-header').css('top',ht+'px');
    $('#main').css('padding-top',(mht+ht)+'px');
  }
});